<template>
    <li
        class="nav-item has-sub"
        :class="{
            open: isOpen,
            hide: item.hide,
            disabled: item.disabled,
            'sidebar-group-active': isActive || childTabActive,
        }"
    >
        <b-link class="d-flex align-items-center" @click="() => updateGroupOpen(!isOpen)">
            <font-awesome-icon :icon="item.icon || ['fas', 'circle']" />
            <span class="menu-title text-truncate">{{ item.title }}</span>
            <b-badge v-if="item.tag" pill :variant="item.tagVariant || 'primary'" class="mr-1 ml-auto">
                {{ item.tag }}
            </b-badge>
        </b-link>
        <b-collapse v-model="isOpen" class="menu-content" tag="ul">
            <component
                :is="resolveNavItemComponent(child)"
                v-for="child in item.children"
                :key="child.header || child.title"
                ref="groupChild"
                :item="child"
            />
        </b-collapse>
    </li>
</template>

<script>
import { mapGetters } from 'vuex';
import { BLink, BBadge, BCollapse } from 'bootstrap-vue';
import VerticalNavMenuLink from './vertical-nav-menu-link.vue';

export default {
    name: 'VerticalNavMenuGroup',
    components: {
        VerticalNavMenuLink,
        BLink,
        BBadge,
        BCollapse,
    },
    props: {
        item: { type: Object, required: true },
    },
    inject: ['openGroups'],
    data() {
        return {
            isOpen: false,
            isActive: false,
            openGroups: this.openGroups,
        };
    },
    computed: {
        ...mapGetters('guest', ['invoicesTab']),
        childTabActive() {
            return this.invoicesTab.includes(this.item.title.toLowerCase());
        },
    },
    methods: {
        resolveNavItemComponent(item) {
            if (item.children) return 'vertical-nav-menu-group';
            return 'vertical-nav-menu-link';
        },
        updateGroupOpen(val) {
            this.isOpen = val;
        },
        doesHaveChild(title) {
            return this.item.children.some((child) => child.title === title);
        },
    },
    watch: {
        openGroups(currentOpenGroups) {
            const clickedGroup = currentOpenGroups[currentOpenGroups.length - 1];
            if (clickedGroup !== this.item.title && !this.isActive) {
                if (!this.doesHaveChild(clickedGroup)) this.isOpen = false;
            }
        },
        isOpen(val) {
            if (val) this.openGroups.push(this.item.title);
        },
    },
};
</script>
